import { validateCompanyName } from "@shared/common/utils/user-form-validation";
import { Form, FormItemProps, Input, InputProps } from "antd";

interface IFormItemInputCompanyName extends FormItemProps {
  input?: InputProps;
}

const FormItemInputCompanyName = ({
  input,
  label,
  className,
  ...props
}: IFormItemInputCompanyName) => {
  return (
    <Form.Item
      label={label}
      name="companyName"
      rules={[
        {
          async validator(_rule, value) {
            validateCompanyName(value);
          },
        },
      ]}
      {...props}
      className={className}
      validateTrigger="onSubmit"
    >
      <Input
        name="companyName"
        type="text"
        placeholder="회사명을 입력해 주세요."
        {...input}
      />
    </Form.Item>
  );
};

export default FormItemInputCompanyName;
